import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { map, Observable } from 'rxjs';
import { CaseShards } from '../models/case-shards.model';
import { CaseShardsResource } from '../models/resource/case-shards.resource';
import { CaseShardsResourceToCaseShardsMapper } from '../models/mappers/case-shards-resource-to-case-shards.mapper';


@Injectable({ providedIn: 'root' })
export class CaseShardsSdk extends SdkBase {

	constructor(
		injector: Injector) {
		super(injector);
	}

	public get(caseId: string): Observable<CaseShards> {
		return this.makeHttpRequest<CaseShardsResource>('get', `api2/caseshards/${caseId}`).pipe(
			map((response) => {
				const mapper = new CaseShardsResourceToCaseShardsMapper();
				return mapper.map(response);
			})
		);
	}

	public put(caseId: string, primaryShardCount: number): Observable<void> {
		return this.makeHttpRequest<void>('put', `api2/caseshards/${caseId}`, { caseId: caseId, primaryShardCount: primaryShardCount });
	}
}

